import { Modal, IconButton, IIconProps } from '@fluentui/react'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { ITemplates } from './UploadTemplate'
import RGL, { WidthProvider } from "react-grid-layout";
import { FontWeights, getTheme, mergeStyleSets } from '@fluentui/react/lib/Styling';
import { CustomForm } from './CustomForm/CustomForm';
import Helper from '../../Helpers/Helper';
import { useFormAssembly } from './CustomTemplate/hooks/useFormAssembly';
import { IFormAssemblyRule } from '../../interfaces/IFormAssembly';

const theme = getTheme();

type WizardPreviewProps = {
    Username: string
    templateId: string
    templateName: string
    layouts: any
    modalPreviewOpen: boolean
    togglePreview: any
    pageCount: any
    released: any
    pageSelected: any
}
const WizardPreview = ({ modalPreviewOpen, templateId, Username, layouts, pageSelected, templateName, pageCount, released, togglePreview }: WizardPreviewProps) => {

    const [contentPreview, setContentPreview] = useState<JSX.Element[]>();
    const { formRules } = useFormAssembly()

    // Fetch the template's Application Image so the preview shows the same top-left
    // logo the public links do. Absent/failed => no logo (matches a link with none).
    const [appLogo, setAppLogo] = useState("")
    useEffect(() => {
        let cancelled = false
        Helper.getDocumentOnlyTemplateId(templateId, true, Username)
            .then((res: any) => { if (!cancelled) setAppLogo((res as ITemplates)?.ImageInfo ?? "") })
            .catch(() => { if (!cancelled) setAppLogo("") })
        return () => { cancelled = true }
    }, [templateId, Username])

    const mappedFormRules: () => IFormAssemblyRule[] = useCallback(() => {
        return formRules.map((rule) => {
            const conditions = rule.conditions.map((condition) => {
                return { ...condition, field: `preview__${condition.field}` }
            })
            const actions = rule.actions.map((action) => {
                if (action.type === 'field')
                    return { ...action, value: `preview__${action.value}` }
                return action
            })
            return { ...rule, conditions, actions: actions }
        })
    }, [formRules])

    const getWizardLayout = useCallback(() => {
        return {
            TemplateId: templateId,
            Owner: Username,
            Layout: [...layouts],
            Pages: pageCount.toString(),
            formRules: mappedFormRules(),
            Released: released
        }
    }, [Username, mappedFormRules, layouts, pageCount, released, templateId])

    return (

        <CustomForm
            allowDrafts={true}
            draftId={null}
            data={null}
            draftBLOB={null}
            loadDocumentDrafts={() => { }}
            closeDraftModal={() => { }}
            parentId={-1}
            isSubform={false}
            documentId={undefined}
            onBehalf={undefined}

            showCustomForm={modalPreviewOpen}
            toggleCustomForm={togglePreview}
            getWizardLayout={getWizardLayout}
            wizardLayouts={layouts}
            pageSelected={pageSelected}
            isWizardPreview={true}
            appLogo={appLogo}
            siteSelected={Helper.getSiteSelected()}
            accountId={Helper.getDefaultAccount()}
            targetUser={Helper.getUsername()}
            username={Helper.getUsername()}
            sessionKey={Helper.getSessionKey()}
            templateId={templateId}
            templateName={`Preview (${templateName})`}
            update={() => { }}
            isCreator={false}
            isOwner={true}
            isCoOwner={false}
            culture={''}
            ownerName={''}
            ownerUser={''}
            templateCategory={''}
            audienceName={''}
            emailMoniker={''}
            documentCreation={''}
            templateEdit={''}
            defaultDescription={''}
        />
    )
}

export default WizardPreview